/** Seed Status Updation — the form, optionally opened on one lot. */
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SeedStatusUpdatePage } from "@/features/warehouse/components/seed-status-update-page";
import { asStage, useDeskFacility } from "@/features/warehouse/route-helpers";
import { guardDesk } from "../../-guard";

export const Route = createFileRoute(
  "/_app/warehouse/$stage/seed-status/update"
)({
  validateSearch: z.object({ lot: z.coerce.number().optional() }),
  beforeLoad: ({ params }) => guardDesk(params.stage, "warehouse.seed_status"),
  component: Page,
});

function Page() {
  const { stage } = Route.useParams();
  const { lot } = Route.useSearch();
  return (
    <SeedStatusUpdatePage
      key={lot ?? "new"}
      stage={asStage(stage)}
      facilityId={useDeskFacility()}
      initialLotId={lot}
    />
  );
}
